module.exports = "https://static.wanderu.com/static/media/time-x2.298286c2.png";